module.exports = __webpack_public_path__ + "img/output_off.156905f5.svg";